import TBCH from "../static/tbch logo.png";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { PulseLoader } from "react-spinners";

export default function Register() {
  const forward = useNavigate();

  useEffect(() => {
    document.title = "Register | TBCH";
  }, []);

  useEffect(() => {
    if (localStorage.getItem("current-user")) {
      forward("/");
    }
  }, [forward]);

  const [message, setMessage] = useState({
    message: "",
    success: true,
  });

  // user
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [secu_key, setSecu_key] = useState("");
  const [sidebar, setSidebar] = useState(false);
  const [load, setLoad] = useState(false);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSecuKey = (e) => {
    setSecu_key(e.target.value);
  };

  const handleRegister = (e) => {
    e.preventDefault();
    setLoad(true);
    if (!name.length || !email.length || !password.length || !secu_key.length) {
      setMessage({
        ...message,
        message: "Important fields missing",
        success: false,
      });
      setLoad(false);
      setTimeout(() => {
        setMessage({ ...message, message: "", success: false });
      }, 2000);
      return;
    }

    if (name.length > 15) {
      setMessage({
        ...message,
        message: "Name is too long. 15 characters only, please.",
        success: false,
      });
      setLoad(false);
      setTimeout(() => {
        setMessage({ ...message, message: "", success: false });
      }, 2000);
      return;
    }

    if (password.length < 10) {
      setMessage({
        ...message,
        message: "Password is too short!",
        success: false,
      });
      setLoad(false);
      setTimeout(() => {
        setMessage({ ...message, message: "", success: false });
      }, 2000);
      return;
    }

    const data = {
      name: name.trim(),
      email: email.trim(),
      password: password.trim(),
      secu_key: secu_key.trim(),
    };

    axios
      .post("/_tbch-api/register", data)
      .then((d) => {
        setMessage({
          ...message,
          message: d.data.message,
          success: d.data.success,
        });
        setLoad(false);
        setTimeout(() => {
          setMessage({ ...message, message: "", success: true });
        }, 5000);
      })
      .catch((e) => {
        setMessage({
          ...message,
          message: "Can't connect to server.",
          success: false,
        });
        setLoad(false);
        setTimeout(() => {
          setMessage({ ...message, message: "", success: false });
        }, 5000);
      });
  };

  const sideBar = () => {
    if (sidebar) {
      return setSidebar(false);
    } else {
      return setSidebar(true);
    }
  };

  return (
    <div className="main">
      <nav
        className="mobile-nav"
        style={
          sidebar
            ? { transform: "translateX(0%)" }
            : { transform: "translateX(100%)" }
        }
      >
        <div className="close-button-wrap">
          <i class="lni lni-cross-circle" onClick={sideBar}></i>
        </div>
        <div className="choices">
          <span>
            <Link to="/">Return</Link>
          </span>
        </div>
        <img src={TBCH} alt="" />
        <div className="mark">
          <span>@ctxsoftwaresphilippines</span>
          <span>@charliecatxph</span>
          <span>
            Designed and developed by : Charl Concepcion, CEO of CTX Softwares
            Philippines
          </span>
        </div>
      </nav>

      <section className="landing-page bg-src">
        <div className="darken"></div>
        <nav className="nav-bar">
          <div className="container">
            <div className="logo">
              <img src={TBCH} alt="" />
            </div>
            <div className="navbar-buttons">
              <div className="button">
                <span>
                  <Link to="/">Return</Link>
                </span>
              </div>
            </div>
            <div className="burger-menu-btn" onClick={sideBar}>
              <i class="lni lni-menu"></i>
            </div>
          </div>
        </nav>
        <div className="container">
          <div className="wrap-form">
            <form onSubmit={handleRegister}>
              <div
                className="message-response"
                style={
                  message.success
                    ? { backgroundColor: "#2ecc71" }
                    : { backgroundColor: "#e74c3c" }
                }
              >
                <span>{message.message}</span>
              </div>
              <h1>Register:</h1>
              <label htmlFor="email">Username</label>
              <input
                type="text"
                name="name"
                id=""
                onChange={handleNameChange}
                required
                placeholder="John Doe"
              />
              <label htmlFor="email">Email</label>
              <input
                type="email"
                name="email"
                id=""
                onChange={handleEmailChange}
                required
                placeholder="myemail@mydomain.com"
              />
              <label htmlFor="password">Password</label>
              <input
                type="password"
                name="password"
                id=""
                onChange={handlePasswordChange}
                required
                placeholder="password"
              />
              <label htmlFor="secu_key">
                Secu-Key® (used when you forget your password)
              </label>
              <input
                type="text"
                name="secu_key"
                id=""
                onChange={handleSecuKey}
                required
                placeholder="SECU_KEY"
              />
              <span>
                <Link to="/login">Already have an account on TBCH?</Link>
              </span>
              <button type="submit" className="submit-btn">
                {load ? (
                  <PulseLoader color={"#FFFFFF"} loading={load} size={5} />
                ) : (
                  "Register"
                )}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}
